import { tv } from "../../variants/tv.js";
const subPanelSlots = {
    containerSlot: '',
    subPanelSlot: ''
};
const subPanelEmphasisVariants = {
    none: {
        subPanelSlot: ''
    },
    medium: {
        subPanelSlot: 'bg-primary-3'
    },
    bold: {
        subPanelSlot: 'bg-actionPrimary-8'
    }
};
const subPanelVariants = tv({
    slots: subPanelSlots,
    variants: {
        position: {
            top: {
                containerSlot: 'flex justify-end',
                subPanelSlot: 'mb-[-20px] rounded-t-lg border-1 border-primary-5 px-2 pt-1 pb-6'
            },
            bottom: {
                containerSlot: 'flex justify-start',
                subPanelSlot: 'mt-[-20px] rounded-b-lg border-1 border-primary-5 px-2 pt-6 pb-1'
            }
        },
        emphasis: subPanelEmphasisVariants
    },
    defaultVariants: {
        position: 'top',
        emphasis: 'none'
    }
});
export { subPanelVariants };
